import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
const DemandForecast = () => {
    // 註冊 `CategoryScale`
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );
    const data = {
        labels: ['January', 'February', 'March', 'April', 'May'],
        datasets: [
            {
                label: 'Demand Prediction',
                data: [300, 400, 350, 450, 500],
                borderColor: 'rgba(255,99,132,1)',
                fill: false,
            },
        ],
    };

    return (
        <div className="p-4">
            <h2 className="text-2xl font-bold mb-4">智慧需求預測</h2>
            <Bar data={data} />
        </div>
    );
};

export default DemandForecast;
